import { useSelector } from 'react-redux';
import {
  FREESTAR_ENABLED,
  FREESTAR_PRIMIS_VIDEO_ENABLED,
  OUTSTREAM_VIDEO_AD_ENABLED,
} from 'src/common/constants/experiments/ads';
import useExperiment from 'src/common/hooks/useExperiment';
import { useStores } from 'src/common/providers';
import { selectRouteGuideId } from 'src/common/selectors/app';
import { useDetermineAdEligibility } from 'src/common/utils/ads/determineAdEligibility';
import determineSponsorshipEnabled from 'src/common/utils/ads/determineSponsorshipEnabled';
import FreeStarVideoAdContainer from './FreeStarVideoAdContainer';
import { OutstreamVideoAd } from './OutstreamVideoAd';

interface OustreamVideoAdSelectorProps {
  id: string;
  isInNowPlayingDialog?: boolean;
}

export function OutstreamVideoAdSelector(props: OustreamVideoAdSelectorProps) {
  const { id, isInNowPlayingDialog } = props;
  const { playerStore } = useStores();
  const { canShowNowPlayingMrecVideoAds = true } = playerStore.metadata()?.ads ?? {};
  const guideId = useSelector(selectRouteGuideId);
  const sponsorshipEnabled = useSelector(determineSponsorshipEnabled(guideId));
  const canShowAds = useDetermineAdEligibility(guideId);
  const isFreestarEnabled = useExperiment(FREESTAR_ENABLED);
  const isFreestarPrimisVideoEnabled = useExperiment(FREESTAR_PRIMIS_VIDEO_ENABLED);
  const isOutstreamVideoAdEnabled = useExperiment(OUTSTREAM_VIDEO_AD_ENABLED);

  if (!canShowAds || sponsorshipEnabled || !canShowNowPlayingMrecVideoAds) {
    return null;
  }

  if (isFreestarEnabled && isFreestarPrimisVideoEnabled && !isOutstreamVideoAdEnabled) {
    return <FreeStarVideoAdContainer isInNowPlayingDialog={isInNowPlayingDialog} />;
  }

  if (isOutstreamVideoAdEnabled) {
    return <OutstreamVideoAd id={id} />;
  }

  return null;
}
